<template>
  <main class="crm-funnels">
    <header class="crm-funnels__header">
      <h1 class="crm-funnels__header__title">CRM</h1>
      <button
        class="crm-funnels__deal-creation-open"
        type="button"
        v-bind:disabled="!hasDealOptions"
        v-on:click="onDealCreationOpen"
      >Создать заявку</button>
      <the-select
        v-if="funnelsIsLoaded"
        title="Воронка"
        placeholder="Выберите воронку"
        class="crm-funnels__header__select"
        v-bind:options="funnelOptions"
        v-bind:value="selectedFunnel"
        v-on:input="onSelectedFunnelInput" />
      <button
        class="crm-funnels__button-filter"
        type="button"
        v-bind:disabled="!hasDealOptions"
        v-on:click="onToggleShownFilters"
        v-bind:class="{ active: shownFilters }"
        v-bind:title="titleButtonFilters"
      >Фильтр</button>
      <div
        class="crm-funnels__filter"
        v-if="hasDealOptions && shownFilters"
      >
        <date-range-with-presets
          class="crm-funnels__filter__presets"
          v-bind:presets="periodPresets"
          v-model="periodDates"
          v-on:input="onChangeFilters" />
        <div class="crm-funnels__filter__form-wrapper">
          <autocomplete-input
            label="Услуга"
            clearable
            item-text="title"
            v-bind:menu-props="{ maxWidth: 'min(80%, 550px)' }"
            v-bind:items="dealOptions.services"
            v-model="selectedService"
            v-on:input="onChangeFilters"
          />
          <autocomplete-input
            label="Врач"
            clearable
            item-text="title"
            v-bind:items="dealOptions.doctors"
            v-model="selectedDoctor"
            v-on:input="onChangeFilters"
          />
          <autocomplete-input
            label="Статус"
            item-text="title"
            clearable
            v-bind:items="statusOptions"
            v-model="selectedStatus"
            v-on:input="onChangeFilters" />
          <autocomplete-input
            label="Канал"
            item-text="title"
            clearable
            v-bind:items="dealOptions.channels"
            v-model="selectedChannel"
            v-on:input="onChangeFilters" />
          <autocomplete-input
            label="Источник"
            item-text="title"
            clearable
            v-bind:items="dealOptions.sources"
            v-model="selectedSource"
            v-on:input="onChangeFilters" />
          <autocomplete-input
            label="Причина отказа"
            item-text="title"
            clearable
            v-bind:items="dealOptions.rejectionReasons"
            v-model="selectedRejectionReason"
            v-on:input="onChangeFilters" />
          <multiple-autocomplete-input
            label="Пациенты"
            removal-per-chip
            v-bind:items="dealOptions.patients"
            v-on:input="onChangeFilters"
            v-model="selectedPatients" />
          <button
            class="crm-funnels__filter__button-reset"
            type="button"
            v-on:click="removeFilters"
          >Сбросить фильтры</button>
        </div>
      </div>
    </header>
    <strong
      class="crm-funnels__message"
      v-if="selectionDescription"
    >{{ selectionDescription }}</strong>
    <section
      v-on:scroll="onScrollBoard"
      class="crm-funnels-board"
      ref="scroller"
      v-else
    >
      <div class="crm-funnels-board__container">
        <div class="crm-funnels-board__wrapper-stage">
          <div
            class="crm-funnels-board__stage"
            v-bind:key="`crm-funnel:head-cells:${stageIndex}`"
            v-for="({
              stageId, name, color, countDeals, isDefault,
            }, stageIndex) in selectedFunnelStages"
            v-on:dragenter="onDragOver"
          >
            <div
              class="crm-funnels-board__stage-header"
              v-bind:style="{ background: color }"
              :ref="`stage-header-${stageId}`"
            >
              <p class="crm-funnels-board__stage-name" :title="name" :data-color="color">
                <span
                  class="crm-funnels-board__stage-blur"
                  v-bind:style="{ background: `linear-gradient(270deg, ${color} 24.48%, rgba(255, 255, 255, 0) 100%)` }"
                />
                <span>{{ name }}</span>
              </p>
              <p class="crm-funnels-board__stage-counter">Заявок {{ countDeals }}</p>
              <popover-menu
                overflow-auto
                v-model="showColorsMenu[stageIndex]">
                <template v-slot:trigger="{ listenerObject }">
                  <button
                    class="crm-funnels-board__color-button"
                    title="Изменить цвет"
                    type="button"
                    @click=setSelectedStageId(stageId)
                    v-on="listenerObject" />
                </template>
                <color-select
                  class="crm-funnels-board__color-select"
                  :color="color"
                  v-on:change-color="changeStageColor(stageId, $event)"
                  :colors="colors" />
                <div
                  class="crm-funnels-board__buttons"
                >
                  <button
                    class="crm-funnels-board__buttons__edit"
                    type="button"
                    v-on:click="openModalFormStage(stageId, name, color, isDefault)">
                    Редактировать
                  </button>
                  <button
                    class="crm-funnels-board__buttons__delete"
                    type="button"
                    v-on:click="onDeleteStage(stageId, isDefault)">
                    Удалить
                  </button>
                </div>
              </popover-menu>
            </div>
            <div
              class="crm-funnels-board__card-container"
              v-on:dragover.prevent
              v-on:drop="onDrop(stageId)"
            >
              <button
                class="crm-funnels-board__card"
                v-bind:key="`crm-funnel:rows:${stageIndex}:cells:${dealIndex}`"
                title="Перейти к редактированию"
                type="button"
                v-for="({
                  patient,
                  phoneNumber,
                  isInitial,
                  dealId,
                  countNewTasks,
                  isArchive,
                }, dealIndex) in selectedFunnelDealsPerStages[stageIndex]"
                v-on:click="onEditDeal(dealId)"
                draggable="true"
                @dragstart="onDragStart(dealId, stageIndex)"
                @dragend="onDragEnd"
              >
                <span class="crm-funnels-board__card-line card-line">
                  <span>
                    <span class="card-line__patient-name">{{ patient }}</span>
                    <span v-if="isInitial" class="card-line__chip" title="Первичный прием">1</span>
                    <span class="card-line__icon-archive" v-if="isArchive" />
                  </span>
                  <a class="card-line__telephone">{{ phoneNumber }}</a>
                  <span
                    v-if="countNewTasks > 0"
                    title="Есть новые задачи"
                    class="card-line__red-chip" />
                </span>
              </button>
            </div>
          </div>
          <button
            class="crm-funnels-board__stage-add"
            type="button"
            title="Добавить этап"
            v-on:click="openModalFormStage()" />
        </div>
      </div>
    </section>
    <side-slide-transition>
      <confirm-side-dialog
        v-bind:label="dealOptions.title"
        v-if="showDealCreationForm"
        v-bind:need-confirm="needConfirmDealCreationForm"
        v-on:cancel="onDealCreationCancel"
      >
        <form-crm-deal-creation
          v-bind:channel-options="dealOptions.channels"
          v-bind:doctor-options="dealOptions.doctors"
          v-bind:funnel-options="dealOptions.funnels"
          v-bind:initial-title="dealOptions.title"
          v-bind:initial-funnel="selectedFunnel"
          v-bind:is-allowed-new-patient="dealOptions.isAllowedNewPatient"
          v-bind:is-allowed-view-phone="dealOptions.isAllowedViewPhone"
          v-bind:is-await-request="isAwaitDealCreationRequest"
          v-bind:matched-patients="dealCreationMatchedPatients"
          v-bind:note-max-length="dealOptions.noteMaxLength"
          v-bind:patient-options="dealOptions.patients"
          v-bind:service-options="dealOptions.services"
          v-bind:source-options="dealOptions.sources"
          v-bind:stage-options="dealOptions.stages"
          v-bind:title-max-length="dealOptions.titleMaxLength"
          v-bind:rejection-reason-options="dealOptions.rejectionReasons"
          v-bind:violations="inputErrors"
          v-bind:is-advertising-channel-required="isAdvertisingChannelRequired"
          v-on:change-values="onChangeDealFormFieldValues"
          v-on:create-advertising-channel="onCreateAdvertisingChannel"
          v-on:input-matching-field="onDealCreationPatientMatch"
          v-on:select-matched-patient="onDealCreationPatientSelect"
          v-on:submit="onDealCreationSubmit" />
      </confirm-side-dialog>
    </side-slide-transition>
    <modal-dialog
      v-if="shownModalFormStage"
      with-cross
      content-class="color-stage-modal"
      v-bind:value="shownModalFormStage"
      v-bind:title="titleModalStageForm"
      v-on:input="closeModalCreatingStage"
    >
      <form-crm-stage
        v-bind:initial-color="selectedStageColor"
        v-bind:initial-name="selectedStageName"
        v-bind:initial-id="selectedStageId"
        v-bind:funnel-id="selectedFunnel"
        v-bind:colors="colors"
        v-bind:violations="stageFormViolations"
        v-on:submit="onSubmitStage" />
    </modal-dialog>
  </main>
</template>
<script>
import ColorSelect from '@/components/ColorSelect.vue';
import ConfirmSideDialog from '@/components/ConfirmSideDialog.vue';
import FormCrmDealCreation from '@/components/FormCrmDealCreation.vue';
import PopoverMenu from '@/components/PopoverMenu.vue';
import SideSlideTransition from '@/components/SideSlideTransition.vue';
import TheSelect from '@/components/TheSelect.vue';
import debounce from 'lodash.debounce';
import notifierMixin from '@/mixins/notifierMixin';
import { GetMatchedPatientsRequest } from '@/storage/gateways/PatientGateway';
import DateRangeWithPresets from '@/components/DateRangeWithPresets.vue';
import { getISODateStringByDate } from '@/mixins/dateMixin';
import ModalDialog from '@/components/ModalDialog.vue';
import FormCrmStage from '@/components/FormCrmStage.vue';
import { CLEAR_CRM_FILTERS, STORE_CRM_FILTERS } from '@/store/actions/crmFilters';
import { builtInDialogMixin, DialogResult } from '@/components/ClinicPanelDialog.vue';
import MultipleAutocompleteInput from '@/components/MultipleAutocompleteInput.vue';
import AutocompleteInput from '@/components/AutocompleteInput.vue';

const crmFunnelsFiltersMixin = {
  computed: {
    titleButtonFilters() {
      return this.shownFilters ? 'Свернуть фильтры' : 'Показать фильтры';
    },
    /**
     * @description Предварительные установки периодов.
     * @returns {{toValue: function(): [Date,Date], id: string, label: string, title: string}[]}
     */
    periodPresets() {
      return this.dealOptions.periodTypes.map(({ periodDates, title, value }) => ({
        id: value,
        label: title,
        title,
        toValue: () => periodDates,
      }));
    },
  },
  data() {
    return {
      periodDates: [],
      selectedPeriodType: '',
      shownFilters: false,
      selectedService: null,
      selectedDoctor: null,
      selectedStatus: null,
      selectedPatients: [],
      selectedChannel: null,
      selectedSource: null,
      selectedRejectionReason: null,
      statusOptions: [
        {
          title: 'Первичный',
          value: 1,
        },
        {
          title: 'Повторный',
          value: 0,
        },
      ],
      scroll: this.$refs.scroll,
    };
  },
  methods: {
    /**
     * @description Переключить отображение фильтров.
     * @returns {void}
     */
    onToggleShownFilters() {
      this.shownFilters = !this.shownFilters;
      this.onChangeFilters();
    },
    /**
     * @description Обработать изменение фильтров.
     */
    onChangeFilters() {
      this.reloadFunnel();
      this.storeFilters();
    },
    /**
     * @description Сбросить фильтры.
     * @returns {void}
     */
    removeFilters() {
      this
        .dealOptions
        .periodTypes
        .slice(0, 1)
        .forEach(({ periodDates, value }) => {
          this.periodDates = periodDates;
          this.selectedPeriodType = value;
        });
      this.selectedStatus = null;
      this.selectedService = null;
      this.selectedPatients = [];
      this.selectedDoctor = null;
      this.selectedStage = null;
      this.selectedChannel = null;
      this.selectedSource = null;
      this.selectedRejectionReason = null;
      this.shownFilters = false;
      this.reloadFunnel();
      this.$store.dispatch(CLEAR_CRM_FILTERS);
    },
  },
};

/**
 * @description Примесь создания этапа воронки.
 */
const crmFunnelsStageCreatingMixin = {
  computed: {
    /**
     * @description Заголовок модального окна форма этапа.
     * @returns {string}
     */
    titleModalStageForm() {
      return this.selectedStageId ? 'Редактирование этапа' : 'Создание этапа';
    },
  },
  data() {
    return {
      /**
       * @description Показывать модальное окно этапа.
       * @type {Boolean}
       */
      shownModalFormStage: false,
      /**
       * @description Ошибки формы этапа.
       * @type {Object}
       */
      stageFormViolations: {},
      /**
       * @description Идентификатор выбранного этапа.
       * @type {string}
       */
      selectedStageId: '',
      /**
       * @description Название выбранного этапа.
       * @type {string}
       */
      selectedStageName: '',
      /**
       * @description Цвет выбранного этапа.
       * @type {string}
       */
      selectedStageColor: '',
      /**
       * @description Статус по умолчанию выбранного этапа.
       * @type {boolean}
       */
      selectedStageDefault: false,
    };
  },
  methods: {
    /**
     * @description Обработать отправку этапа.
     * @param {CreationStageRequest} request
     */
    onSubmitStage(request) {
      if (request.getStageId() !== '') {
        this.onEditStage(request);
      } else {
        this.onCreateStage(request);
      }
    },
    /**
     * @description Обработать создание этапа.
     * @param {CreationStageRequest} request
     */
    onCreateStage(request) {
      this
        .$crmGateway
        .createStage(request.getFunnelId(), request.toQuery())
        .then((result) => {
          result.forEachLeft((error) => {
            this.notifyFail(error.title);
            const failurePairs = (error.causes || []).map((cause) => [cause.source, cause.details]);
            this.stageFormViolations = Object.fromEntries(failurePairs);
          });
          result.forEach((response) => {
            this.notifySuccess(response.title);
            this.closeModalCreatingStage();
            this.fetchDealOptions();
            this.reloadFunnel();
            this.selectedIdOfElementStage = response.id;
          });
        })
        .finally(() => {
          setTimeout(this.scrollToNeedStage, 500);
        });
    },
    /**
     * @description Обработать редактирование этапа.
     * @param {CreationStageRequest} request
     */
    async onEditStage(request) {
      if (this.selectedStageDefault) {
        const message = 'Внимание! При изменении данного этапа все правила автоматизации будут удалены. Продолжить?';
        const dialog = await this.showAcceptDialog(message);
        if (dialog.result !== DialogResult.YES) {
          this.closeModalCreatingStage();
          return;
        }
      }
      this
        .$crmGateway
        .editStage(request.getFunnelId(), request.getStageId(), request.toQuery())
        .then((result) => {
          result.forEachLeft((error) => {
            this.notifyFail(error.title);
            const failurePairs = (error.causes || []).map((cause) => [cause.source, cause.details]);
            this.stageFormViolations = Object.fromEntries(failurePairs);
          });
          result.forEach((response) => {
            this.notifySuccess(response.title);
            this.closeModalCreatingStage();
            this.fetchDealOptions();
            this.reloadFunnel();
          });
        })
        .finally(() => {
          setTimeout(this.scrollToNeedStage, 500);
        });
    },
    /**
     * @description Обработать удаление CRM-этапа.
     * @param {string}  stageId
     * @param {boolean} isDefault
     * @returns {void}
     */
    async onDeleteStage(stageId, isDefault) {
      let message = 'Вы действительно хотите удалить этап?';
      if (isDefault) {
        message = `${message} Внимание! При удалении данного этапа все правила автоматизации будут удалены.`;
      }
      const dialog = await this.showAcceptDialog(message);
      if (dialog.result !== DialogResult.YES) {
        return;
      }
      this.defineSelectedStageId(stageId);
      this
        .$crmGateway
        .deleteStage(this.selectedFunnel, stageId)
        .then((result) => {
          result.forEachLeft((error) => {
            this.notifyFail(error.title);
            const failurePairs = (error.causes || []).map((cause) => [cause.source, cause.details]);
            if (failurePairs.length === 0) {
              this.clarifyAndNotifyFail('blocking')(
                error.title,
                error.detail || '',
                error.telegramLink,
                error.whatsAppLink,
              );
            }
          });
          result.forEach((response) => {
            this.notifySuccess(response.title);
            this.fetchDealOptions();
            this.reloadFunnel();
          });
        })
        .finally(() => {
          setTimeout(this.scrollToNeedStage, 500);
        });
    },
    /**
     * Проскролить до редактируемого ранее этапа
     *
     * @returns null
     */
    scrollToNeedStage() {
      const stageId = this.selectedIdOfElementStage;
      const element = this.$refs[`stage-header-${stageId}`];
      const { scroller } = this.$refs;
      if (scroller && element) {
        scroller.animate({ scrollCenter: element[0] }, 500);
        element[0].scrollIntoView({ behavior: 'smooth' });
      }
    },
    /**
     * Вставить Id редактируемого этапа
     *
     * @param id
     */
    setSelectedStageId(id) {
      this.selectedIdOfElementStage = id;
    },
    /**
     * Определяем следующий выбранный этап
     *
     * @param stageId
     *
     * @returns void
     */
    defineSelectedStageId(stageId) {
      const deleteStage = this
        .selectedFunnelStages
        .find(((el) => el.stageId === stageId));
      const deleteStageIndex = this
        .selectedFunnelStages
        .indexOf(deleteStage);
      const nextIndex = deleteStageIndex > this.selectedFunnelStages.length / 2
        ? deleteStageIndex - 1
        : deleteStageIndex + 1;
      this.selectedIdOfElementStage = this.selectedFunnelStages[nextIndex].stageId;
    },
    /**
     * @description Открыть форму создания этапа.
     *
     * @param {string}  stageId
     * @param {string}  name
     * @param {string}  color
     * @param {boolean} isDefault
     */
    openModalFormStage(stageId = '', name = '', color = '', isDefault = false) {
      this.selectedStageId = stageId;
      this.selectedStageName = name;
      this.selectedStageColor = color;
      this.selectedStageDefault = isDefault;
      this.shownModalFormStage = true;
    },
    /**
     * @description Закрыть форму создания этапа.
     * @returns {void}
     */
    closeModalCreatingStage() {
      this.shownModalFormStage = false;
      this.stageFormViolations = {};
    },
  },
};

/**
 * @description Примесь перетаскивания CRM-заявок
 */
const crmDealsDragAndDropMixin = {
  data() {
    return {
      /**
       * @description Идентификатор переносимой заявки.
       */
      draggedDealId: null,
      /**
       * @description Индекс этапа с которого осуществляется перенос.
       */
      draggedFromStageIndex: null,
      /**
       * @description Выбранный id элемента стадии
       *
       * @type Number
       */
      selectedIdOfElementStage: null,
    };
  },
  methods: {
    /**
     * @description Обработать начало переноса.
     * @param {number} dealId
     * @param {number} stageIndex
     * @returns {void}
     */
    onDragStart(dealId, stageIndex) {
      this.draggedDealId = dealId;
      this.draggedFromStageIndex = stageIndex;
    },
    /**
     * @description Обработать конец переноса.
     * @returns {void}
     */
    onDragEnd() {
      this.draggedDealId = null;
      this.draggedFromStageIndex = null;
    },
    /**
     * @description Обработать сброс.
     * @param {number} stageId
     * @returns {void}
     */
    onDrop(stageId) {
      this.disableDragSelectedStyle();
      if (this.draggedDealId !== null && this.draggedFromStageIndex !== null) {
        const deal = this.selectedFunnelDealsPerStages[this.draggedFromStageIndex].find(
          ({ dealId }) => dealId === this.draggedDealId,
        );
        if (deal) {
          this.updateDealStage(this.draggedDealId, stageId);
          this.notifySuccess('Данные о заявке обновлены');
        } else {
          this.notifyFail('Данная заявка не найдена');
        }
      }
    },
    /**
     * @description Обновить этап заявки.
     * @param {number} dealId
     * @param {number} stageId
     * @returns {void}
     */
    updateDealStage(dealId, stageId) {
      this
        .$crmGateway
        .updateDealStage(dealId, stageId)
        .then((result) => {
          result.forEachLeft((error) => {
            this.notifyFail(error.title);
          });
          result.forEach(() => {
            this.page = 1;
            this.allDealsLoaded = false;
            this.fetchFunnel();
          });
        });
    },
  },
};

/**
 * @description Раздел CRM-воронок.
 * @type {Vue}
 */
export default {
  components: {
    MultipleAutocompleteInput,
    AutocompleteInput,
    FormCrmStage,
    ModalDialog,
    DateRangeWithPresets,
    ColorSelect,
    ConfirmSideDialog,
    FormCrmDealCreation,
    PopoverMenu,
    SideSlideTransition,
    TheSelect,
  },
  computed: {
    /**
     * @description Имеет создание заявки.
     */
    hasDealOptions() {
      return this.dealOptions !== null;
    },
    /**
     * @description Обязательность заполнения источника при создании нового пациента.
     */
    isAdvertisingChannelRequired() {
      return this.dealOptions?.isAdvertisingChannelRequired || false;
    },
    /**
     * @description Пояснение к выбору воронки.
     */
    selectionDescription() {
      if (this.isFetchingSelectedFunnel) {
        return 'Получение данных выбранной воронки...';
      }
      if (this.selectedFunnel === '') {
        return 'Выберите воронку для показа';
      }
      return '';
    },
  },
  created() {
    this.fetchFunnelSelection().then(() => {
      this.funnelsIsLoaded = true;
      this
        .fetchDealOptions()
        .then(() => {
          if (this.$store.getters.isNeedConfirmCrmFilters) {
            this.applyFilters(this.$store.getters.getCrmFilters);
          }
          const funnel = this.funnelOptions.find(({ value }) => value === this.selectedFunnel);
          if (!funnel) {
            this.funnelOptions.slice(0, 1).forEach(({ value }) => {
              this.onSelectedFunnelInput(value);
            });
          } else if (funnel) {
            this.fetchFunnel();
          }
        });
    });
  },
  data() {
    return {
      /**
       * @description Найденные пациенты при создании сделки.
       * @type {object[]}
       */
      dealCreationMatchedPatients: [],
      /**
       * @description Данные создания заявки.
       * @type {object}
       */
      dealOptions: null,
      /**
       * @description Опции воронок.
       * @type {object[]}
       */
      funnelOptions: [],
      /**
       * @description Получение данных выбранной воронки.
       * @type {boolean}
       */
      isFetchingSelectedFunnel: false,
      /**
       * @description Выбранная воронка.
       * @type {string}
       */
      selectedFunnel: this.initialSelectedFunnel,
      /**
       * @description Заявки по этапам для выбранной воронки.
       * @type {object[]}
       */
      selectedFunnelDealsPerStages: [],
      /**
       * @description Этапы выбранной воронки.
       * @type {object[]}
       */
      selectedFunnelStages: [],
      showColorsMenu: [],
      page: 1,
      isAwaitDealCreationRequest: false,
      isFetchingDeals: false,
      allDealsLoaded: false,
      showDealCreationForm: false,
      needConfirmDealCreationForm: false,
      inputErrors: {},
      /**
       * @description Список доступных цветов.
       * @type {string[]}
       */
      colors: [
        '#D2EDB0',
        '#F8EECC',
        '#E7EFFA',
        '#EBF7BB',
        '#FFECEC',
        '#FFD1D1',
        '#BFFEEB',
        '#C8D9F2',
        '#D7D4FF',
        '#F1D4FF',
        '#FFD4EB',
        '#FFD9D4',
        '#D4F0FF',
        '#FFE693',
        '#EFF198',
        '#A6F4CA',
        '#DFB1FB',
        '#B1B8FB',
        '#FBB1E2',
        '#FBB1B1',
        '#A5F4A4',
        '#FFC793',
        '#9ADAEF',
        '#DFDFE2',
      ],
      funnelsIsLoaded: false,
    };
  },
  methods: {
    /**
     * @description Применить фильтры.
     * @param {Object} filters
     */
    applyFilters(filters) {
      this.periodDates = filters.periodDates;
      this.selectedFunnel = filters.selectedFunnel;
      this.selectedService = filters.selectedService;
      this.selectedDoctor = filters.selectedDoctor;
      this.selectedStatus = filters.selectedStatus;
      this.selectedChannel = filters.selectedChannel;
      this.selectedSource = filters.selectedSource;
      this.selectedPatients = filters.selectedPatients;
      this.shownFilters = filters.shownFilters;
      this.selectedRejectionReason = filters.selectedRejectionReason;
    },
    /**
     * @description Обработать скролл доски заявок.
     * @returns {void}
     */
    onScrollBoard() {
      const bottomOfWindow = window.innerHeight
        + window.scrollY >= document.documentElement.offsetHeight - 10;
      if (bottomOfWindow && !this.isFetchingDeals && !this.allDealsLoaded) {
        this.page += 1;
        this.fetchDealsByFunnel();
      }
    },
    /**
     * @description Обработать изменения значений полей формы.
     * @param {string}  form
     * @param {boolean} isChange
     * @returns {void}
     */
    onChangeDealFormFieldValues(form, isChange) {
      this.needConfirmDealCreationForm = isChange;
    },
    /**
     * @description Перейти к редактированию заявки.
     * @param {string} id
     */
    onEditDeal(id) {
      this.$router.push({ name: 'ClinicPanelCrmDeal', params: { id } });
    },
    /**
     * @description Получить опции создания заявки.
     * @returns {Promise}
     */
    fetchDealOptions() {
      return this
        .$crmGateway
        .viewDealOptions()
        .then((result) => {
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
          result.forEach((dealOptions) => {
            this.dealOptions = dealOptions;
          });
        });
    },
    /**
     * @description перезагрузить воронку.
     */
    reloadFunnel() {
      this.isFetchingSelectedFunnel = true;
      this.page = 1;
      this.allDealsLoaded = false;
      this.fetchFunnel();
    },
    /**
     * @description Получить воронку.
     * @returns {void}
     */
    fetchFunnel() {
      const [dateFrom, dateTo] = this.periodDates.map(getISODateStringByDate);
      this
        .$crmGateway
        .viewFunnel(
          this.selectedFunnel,
          this.page,
          dateFrom,
          dateTo,
          this.selectedService,
          this.selectedDoctor,
          this.selectedStatus,
          this.selectedChannel,
          this.selectedSource,
          this.selectedRejectionReason,
          this.selectedPatients,
        )
        .then((result) => {
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
          result.forEach(({ dealsPerStages, stages }) => {
            this.selectedFunnelDealsPerStages = dealsPerStages;
            this.selectedFunnelStages = stages;
            this.showColorsMenu = stages.map(() => false);
          });
        })
        .finally(() => {
          this.isFetchingSelectedFunnel = false;
        });
    },
    /**
     * @description Получить сделки по воронке.
     */
    fetchDealsByFunnel() {
      this.isFetchingDeals = true;
      this.allDealsLoaded = true;
      const [dateFrom, dateTo] = this.periodDates.map(getISODateStringByDate);
      this.$crmGateway
        .viewFunnel(
          this.selectedFunnel,
          this.page,
          dateFrom,
          dateTo,
          this.selectedService,
          this.selectedDoctor,
          this.selectedStatus,
          this.selectedChannel,
          this.selectedSource,
          this.selectedRejectionReason,
          this.selectedPatients,
        )
        .then((result) => {
          result.forEachLeft(({ title }) => {
            this.notifyFail(title);
          });
          result.forEach(({ dealsPerStages }) => {
            dealsPerStages.forEach((stage, index) => {
              if (stage.length !== 0) {
                this.allDealsLoaded = false;
              }
              this.selectedFunnelDealsPerStages[index].push(...stage);
            });
          });
        })
        .finally(() => {
          this.isFetchingDeals = false;
        });
    },
    /**
     * @description Получить выбор воронок.
     * @returns {Promise<void>}
     */
    fetchFunnelSelection() {
      this.funnelsIsLoaded = false;
      return this
        .$crmGateway
        .viewFunnelSelection()
        .then((result) => {
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
          result.forEach(({ items }) => {
            this.funnelOptions = items;
          });
        });
    },
    /**
     * @description Изменить цвет заголовка стадии воронки.
     * @returns {Promise<void>}
     */
    changeStageColor(id, color) {
      this
        .$crmGateway
        .changeFunnelStageColor(this.selectedFunnel, id, color)
        .then((result) => {
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
          result.forEach(({ title }) => {
            this.notifySuccess(title);
            this.reloadFunnel();
          });
        })
        .finally(() => {
          setTimeout(this.scrollToNeedStage, 500);
        });
    },
    /**
     * @description Обработать создание рекламного канала.
     * @returns {void}
     */
    async onCreateAdvertisingChannel(channel) {
      const onFail = (error) => {
        this.notifyFail(error.title);
        const failurePairs = error.causes.map(
          (cause) => ['custom-advertising-channel', cause.details],
        );
        this.inputErrors = Object.fromEntries(failurePairs) || {};
      };
      const onSuccess = ({ message }) => {
        this.notifySuccess(message);
        this.fetchDealOptions();
      };
      const either = await this.$advertisingChannelGateway.create(channel);
      return either.fold(onFail, onSuccess);
    },
    /**
     * @description Обработать отмену создания заявки.
     * @returns {void}
     */
    onDealCreationCancel() {
      this.showDealCreationForm = false;
      this.dealCreationMatchedPatients = [];
    },
    /**
     * @description Обработать создание заявки.
     * @returns {void}
     */
    onDealCreationOpen() {
      this.showDealCreationForm = true;
    },
    /**
     * @description Обработать поиск пациентов при создании сделки.
     * @param {(object|null)} patient Данные нового пациента.
     * @returns void
     */
    onDealCreationPatientMatch: debounce(function _(patient) {
      if (patient !== null) {
        const request = new GetMatchedPatientsRequest(
          patient.name,
          patient.patronymic,
          patient.phone !== '' ? [patient.phone] : [],
          patient.surname,
        );
        this.$patientGateway.getMatchedPatients(request).then((result) => {
          result.forEachFail(({ title }) => { this.notifyFail(title); });
          result
            .forEach((patients) => {
              this.dealCreationMatchedPatients = patients;
            });
        });
      }
      this.dealCreationMatchedPatients = [];
    }, 300),
    /**
     * @description Обработать выбор найденного пациента при создании сделки.
     * @returns {void}
     */
    onDealCreationPatientSelect() {
      this.dealCreationMatchedPatients = [];
    },
    /**
     * @description Логика перетаскивания элемента
     * (При наведении на другой элемент подсвечивать его)
     * @param {event} event
     * @returns {void}
     */
    onDragOver(event) {
      this.disableDragSelectedStyle();
      this.setPointedClass(event);
    },
    /**
     * @description поставить класс "Наведенный элемент".
     * @param {event} event Элемент categoryItem.
     * @returns {void}
     */
    setPointedClass(event) {
      const classNeedElement = 'crm-funnels-board__stage';
      const newClass = 'crm-funnels-board__stage-pointed';
      const element = this.getElementByClassName(classNeedElement, event);
      element.classList.add(newClass);
    },
    /**
     * Найти нужный элемент по классу
     *
     * @param classNeedElement {string}
     * @param event {event}
     * @return {Element}
     */
    getElementByClassName(classNeedElement, event) {
      const { clientX, clientY } = event;
      let element = document.elementFromPoint(clientX, clientY);
      if (!element.classList.contains(classNeedElement)) {
        element = element.closest(`.${classNeedElement}`);
      }
      return element;
    },
    /**
     * @description Отключить стили для прежде наведенных элементов
     *
     * @return {void}
     */
    disableDragSelectedStyle() {
      document.querySelectorAll('.crm-funnels-board__stage-pointed')
        .forEach((el) => {
          el.classList.remove('crm-funnels-board__stage-pointed');
        });
    },
    /**
     * @description Обработать отправку создания заявки.
     * @param {object} data Данные.
     * @returns {void}
     */
    async onDealCreationSubmit(data) {
      this.isAwaitDealCreationRequest = true;
      this.inputErrors = {};
      (
        data.needsCreatingPatient
          ? this.$crmGateway.createNewPatientDeal(data)
          : this.$crmGateway.createDeal(data)
      )
        .then((result) => {
          result.forEachLeft(async (error) => {
            const failurePairs = (error.causes || []).map((cause) => [cause.source, cause.details]);
            this.inputErrors = Object.fromEntries(failurePairs);
            if (error.change_stage) {
              const dialog = await this.showAcceptDialog(error.title);
              if (dialog.result === DialogResult.YES) {
                this.changeDealStage(data.stage, error.deal_id);
              } else {
                this.onDealCreationCancel();
              }
            } else if (failurePairs.length === 0) {
              this.clarifyAndNotifyFail(error.interaction)(
                error.title,
                error.detail || '',
                error.telegramLink,
                error.whatsAppLink,
              );
            }
          });
          result.forEach(({ title }) => {
            this.notifySuccess(title);
            this.onDealCreationCancel();
            if (this.selectedFunnel !== '') {
              this.reloadFunnel();
            }
          });
        })
        .finally(() => { this.isAwaitDealCreationRequest = false; });
    },
    /**
     * @description Обработать смену воронки.
     * @param {string} selectedValue Выбранное значение.
     * @returns {void}
     */
    onSelectedFunnelInput(selectedValue) {
      this.selectedFunnel = selectedValue;
      this.reloadFunnel();
      this.storeFilters();
      this.$router.replace({
        name: 'ClinicPanelCrmFunnels',
        params: { funnel: selectedValue },
      });
    },
    /**
     * @description Сохранить фильтры в хранилище.
     * @returns {void}
     */
    storeFilters() {
      const filters = {
        periodDates: this.periodDates,
        selectedFunnel: this.selectedFunnel,
        selectedService: this.selectedService,
        selectedDoctor: this.selectedDoctor,
        selectedStatus: this.selectedStatus,
        selectedChannel: this.selectedChannel,
        selectedSource: this.selectedSource,
        selectedPatients: this.selectedPatients,
        shownFilters: this.shownFilters,
        selectedRejectionReason: this.selectedRejectionReason,
      };
      this.$store.dispatch(STORE_CRM_FILTERS, filters);
    },
    /**
     * @description Изменить этап заявки.
     * @param {number} stage
     * @param {number} dealId
     */
    changeDealStage(stage, dealId) {
      this
        .$crmGateway
        .changeDealStage(dealId, stage)
        .then((result) => {
          result.forEachLeft(async (error) => {
            this.notifyFail(error.title);
          });
          result.forEach(({ title }) => {
            this.notifySuccess(title);
            this.onDealCreationCancel();
            if (this.selectedFunnel !== '') {
              this.reloadFunnel();
            }
          });
        });
    },
  },
  mixins: [
    notifierMixin,
    crmFunnelsFiltersMixin,
    crmFunnelsStageCreatingMixin,
    crmDealsDragAndDropMixin,
    builtInDialogMixin,
  ],
  name: 'ClinicPanelCrmFunnels',
  props: {
    /**
     * @description Изначальный выбор воронки.
     */
    initialSelectedFunnel: {
      default: () => '',
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
@use "@/scss/buttons";

.crm-funnels {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  &__header {
    display: grid;
    align-items: end;
    grid: repeat(2, max-content) / min(20rem, 100%) 1fr;
    gap: 26px;
    margin-bottom: 10px;
    padding: 36px 27px 34px 37px;
    &__select {
      min-width: 235px;
    }
  }
  &__deal-creation-open {
    @include buttons.btn-blue(15rem, 3rem, 1rem);
    max-width: 210px;
    margin-left: auto;
    &::before {
      content: "+";
      margin: 0 12px 0 0;
      color: #ffffff;
      font-size: 1rem;
    }
  }
  &__button-filter {
    display: flex;
    align-items: center;
    column-gap: 4px;
    max-width: 165px;
    height: 40px;
    font-size: 16px;
    line-height: 20px;
    color: #0489e0;
    &::before {
      content: '';
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      background: url("@/assets/img/filter.svg") no-repeat center;
      background-size: 16px;
    }
    &::after {
      content: "";
      background-image: url("@/assets/img/checked/checked-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 8px;
      margin: 0 0 0 3px;
    }
    &.active::after {
      transform: rotate(180deg);
    }
  }
  &__filter {
    grid-column: 1 / -1;
    &__presets {
      gap: 18px;
      margin-bottom: 23px;
      ::v-deep {
        .date-range-with-presets__search,
        .date-range-with-presets__modes {
          width: min(100%, 306px);
        }
        .date-range-with-presets__search {
          span {
            margin-inline: 2px;
          }
        }
        .date-range-with-presets__modes {
          label {
            width: 100%;
          }
        }
      }
    }
    &__form-wrapper {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-end;
      gap: 18px;
      label, div:not(:last-of-type) {
        width: min(100%, 240px);
      }
    }
    &__button-reset {
      display: flex;
      align-items: center;
      column-gap: 2px;
      height: 40px;
      font-size: 16px;
      line-height: 20px;
      color: #0489e0;
      &::before {
        content: '';
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        background: url("@/assets/img/cross-blue.svg") no-repeat center;
        background-size: 16px;
      }
    }
  }

  &__message {
    padding: 10px 0 0 20px;
  }
}

.crm-funnels-board {
  display: flex;
  flex-grow: 1;
  align-items: stretch;
  padding: 0 27px 10px 37px;
  font-family: "PT Sans", sans-serif;
  font-size: .825rem;
  overflow-y: auto;
  text-align: center;
  &__wrapper-stage {
    display: flex;
    column-gap: 10px;
    padding-bottom: 10px;
  }
  &__stage {
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    width: min(100%, 262px);
  }
  &__card-container {
    min-height: 300px;
  }
  &__card {
    padding: 10px;
    width: 100%;
    text-align: left;
    background-color: var(--section-background-color);
    border-radius: var(--block-border-radius);
    transition: box-shadow 0.3s;
    @media (hover: hover) {
      &:hover {
        box-shadow: 0 0 22px 0px rgba(156, 159, 161, 0.88);
      }
    }
  }
  &__card-line {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__card:nth-child(n + 2) {
    margin-top: 5px;
  }
  &__stage-pointed {
    background-color: azure;
  }
  &__stage-add {
    flex-shrink: 0;
    align-self: flex-start;
    padding-right: 40px;
    width: 30px;
    min-height: 67px;
    background: url("@/assets/img/plus.svg") no-repeat left center;
    background-size: 30px;
    transition: 0.2s;
    &:hover {
      transform: scale(1.3);
    }
    &:active {
      opacity: 0.6;;
    }
  }
  &__stage-header {
    position: sticky;
    top: 0;
    display: grid;
    align-content: space-between;
    row-gap: 10px;
    margin-bottom: 10px;
    padding: 10px;
    width: 100%;
    min-height: 64px;
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
    color: #323c47;
    text-align: left;
    background-color: var(--unfocus-color);
    z-index: 2;
  }
  &__stage-name {
    position: relative;
    max-width: 235px;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
  }
  &__stage-blur {
    position: absolute;
    right: 0;
    width: 45px;
    height: 100%;
    background: linear-gradient(270deg, var(--unfocus-color) 24.48%, rgba(255, 255, 255, 0) 100%);
    z-index: 99;
  }
  &__stage-counter {
    position: relative;
    display: inline-block;
    margin-bottom: 0;
    width: 100%;
    font-size: 13px;
    line-height: normal;
    text-align: left;
  }
  &__color-button {
    background-image: url("@/assets/img/points-white.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    position: absolute;
    right: 0;
    top: 50%;
    width: 20px;
    height: 20px;
    cursor: pointer;
    transform: translateY(-50%);
  }
  &__color-select {
    padding: 15px 24px;
  }
  &__buttons {
    display: flex;
    gap: 1rem;
    padding-inline: 24px;
    margin-bottom: 15px;
    &__edit {
      @include buttons.btn-blue(50%, 3rem, 1rem);
    }
    &__delete {
      @include buttons.btn-blue(50%, 3rem, 1rem);
    }
  }

  .card-line {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 4px;
    &__chip {
      font-family: Roboto,sans-serif;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      border-radius: 12px;
      font-weight: 400;
      font-size: 12px;
      line-height: 12px;
      padding: 2px 6px;
      margin-left: 10px;
      color: #323c47;
      cursor: help;
    }
    &__icon {
      &-archive {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-image: url("@/assets/img/archive-add-blue.svg");
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
      }
    }
    &__red-chip {
      position: absolute;
      right: 0;
      bottom: 0;
      background: #B82428;
      border-radius: 50%;
      padding: 2px 6px;
      width: 12px;
      height: 12px;
      margin-left: auto;
    }
    &__patient {
      font-size: 14px;
      color: #90a0b7;
    }
    &__patient-name {
      font-size: 15px;
      color: #323c47;
    }
    &__telephone {
      font-size: 14px;
      font-weight: 500;
      color: #323c47;
      text-decoration: none;
    }
  }
}

@media screen and (max-width: 640px) {
  .crm-funnels {
    &__header {
      grid: repeat(2, 1fr) / 1fr 1fr;
      &__select {
        max-width: 350px;
      }
    }
    &__deal-creation-open {
      margin-top: 10px;
      margin-left: 0;
    }
  }
}

@media screen and (max-width: 550px) {
  .crm-funnels {
    &__header {
      grid: repeat(3, 1fr) / 1fr;
      gap: 10px;
    }
    &__filter {
      &__form-wrapper {
        label, div {
          width: 100% !important;
        }
      }
    }
  }
}

@media screen and (max-width: 400px) {
  .crm-funnels-board {
    &__buttons {
      flex-direction: column;
      &__edit,
      &__delete {
        width: 100%;
      }
    }
  }
}
</style>
